import React from 'react'

export const OptionTemplate = (option) => {
    return (
        <div className="country-item" title={option.name}>
            <div className="p-text-nowrap p-text-truncate select-option-custom">{option.name}</div>
        </div>
    );
}
